@if (breadcrumb.length > 0 && !pdf) {
    <div fxLayout="row" class="drilldown-component__breadcrumb">
        @for (visualization of breadcrumb; track $index) {
            <div
                class="drilldown-component__breadcrumb-item"
                fxLayout="row"
                fxLayoutAlign="start center"
            >
                <span
                    class="drilldown-component__breadcrumb-item-text"
                    [class.drilldown-component__breadcrumb-item-text--active]="
                        $index === breadcrumb.length - 1
                    "
                    (click)="onBreadcrumbClick($index)"
                >
                    {{ visualization.props.name }}
                </span>
                @if ($index < breadcrumb.length - 1) {
                    <i
                        class="fa-solid fa-chevron-right drilldown-component__breadcrumb-item-separator"
                    ></i>
                }
            </div>
        }
    </div>
}
<div
    class="drilldown-component"
    [class.drilldown-component--pdf]="pdf"
    fxLayout="row"
>
    @if (loadingDrilldown || loading) {
        <dsn-skeleton-loader
            [type]="'rectangle'"
            [width]="'300px'"
            [height]="'68px'"
        ></dsn-skeleton-loader>
    } @else {
        @if (drilldownVisualizations.length > 0) {
            @for (drilldown of drilldownVisualizations; track $index) {
                <div
                    class="drilldown-component__card"
                    [class.drilldown-component__card--fullwidth]="
                        isMobile() && options.comparation.active
                    "
                    (click)="onVisualizationClick(drilldown.visualization)"
                    fxLayout="column"
                    fxFlex
                >
                    <app-visualization
                        [loading]="false"
                        style="height: 100%; max-height: 100%"
                        [visualization]="drilldown.visualization"
                        [company]="company"
                        [options]="drilldown.options"
                        [absoluteChartArea]="true"
                        [isDrilldown]="true"
                        [suffixIndicatorValues]="drilldown.suffix || ''"
                        [isAccumulated]="isAccumulated"
                    ></app-visualization>
                </div>
            }
        }
    }
</div>
